import React from 'react';

const Formations = () => {
    return (
        <div>

        </div>
    );
};

export default Formations;